import { Add } from '@mui/icons-material'
import { Box, Skeleton, Typography } from '@mui/material'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import React from 'react'
import { CustomCategoryList } from './CategoryLists'
import PayrollCategoryModal from './PayrollCategoryModal'
import AdxButton from 'components/custom/AdxButton'

const CustomCategoryTabPanel = ({
  label,
  loading,
  customList,
  categoryIndex1,
  categoryIndex2 = null,
  newId,
}) => {
  let customArr = new Array(5).fill('i')
  return (
    <AdxTabsPanel label={label}>
      {loading
        ? customArr.map((arr, index) => (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              padding={2}
              key={index}
            >
              <Box display="flex" alignItems="center" sx={{ width: 'calc(100% * 2 / 5)', mr: 2 }}>
                <Typography variant="subtitle1" mr={2}>
                  <Skeleton width={200} />
                </Typography>
              </Box>
              <Box sx={{ width: 'calc(100% * 2 / 5)' }} display="flex">
                <Typography variant="subtitle1" sx={{ mr: 1 }}>
                  <Skeleton width={200} />
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                sx={{ width: 'calc(100% * 1 / 5)' }}
              >
                <Typography variant="subtitle1">
                  <Skeleton width={20} />
                </Typography>
                <Typography ml={2} variant="subtitle1">
                  <Skeleton width={20} />
                </Typography>
              </Box>
            </Box>
          ))
        : customList
            ?.filter((filtered) => {
              if (
                filtered?.custom_status === categoryIndex1 ||
                filtered.custom_status === categoryIndex2
              ) {
                return filtered
              } else {
                return null
              }
            })
            ?.map((list, index) => (
              <CustomCategoryList
                props={newId}
                details={list}
                key={index}
                sx={{
                  borderBottom: index !== list.length && 1,
                  borderColor: 'gray-line.main',
                }}
              />
            ))}
      <Box sx={{ p: 0.5 }}>
        <PayrollCategoryModal props={newId}>
          <AdxButton
            variant={'ghost'}
            sx={{
              width: 1,
              display: 'flex',
              justifyContent: 'center',
              px: 2,
              alignItems: 'center',
            }}
            startIcon={<Add />}
          >
            {newId && `Add new ${newId?.item?.toLowerCase()}`}
          </AdxButton>
        </PayrollCategoryModal>
      </Box>
    </AdxTabsPanel>
  )
}

export default CustomCategoryTabPanel
